//import { getMockOrderHistory } from "../__mocks__/orderHistoryApi";
import api from "../api";
import RestEndpoints from "../constants/RestEndpoints";

export const getOrderHistory = async () => {
  return api.get<any>(RestEndpoints.ORDER.ORDER_HISTORY);
};
